import Vue from 'vue'
import router from '../../router'

export default {
  loadAboutGrottbjornPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`settings/change-publications-photo/${id}`, formData)
  },
  deleteAboutGrottbjornPhoto ({ commit }, id) {
    commit('DELETE_ABOUT_PHOTO')
  },
  addPublication ({ commit }, data) {
    commit('ADD_NEW_PUBLICATION', data)
    router.push({ name: 'PublicationCreator', params: { id: data.id } })
  },
  addPublicationPhoto ({ commit }, publication) {
    commit('ADD_PUBLICATION_PHOTO', publication)
  },
  deletePublicationPhoto ({ commit }) {
    commit('DELETE_PUBLICATION_PHOTO')
  },
  deletePublication ({ commit }, id) {
    return Vue.axios.delete(`about/publications/${id}`)
    .then(({ data }) => {
      commit('DELETE_PUBLICATION', data)
      router.push({ name: 'AllPublications' })
    })
  },
  updatePublication ({ commit }, publication) {
    commit('UPDATE_PUBLICATION', publication)
  },
  savePublication ({ commit, dispatch }, publication) {
    let newPhoto
    if (publication.photo && publication.photo.base64photo) {
      newPhoto = publication.photo.data
      publication.photo = ''
    }
    return Vue.axios.put(`about/publications`, { publication })
    .then(() => {
      delete publication.isNew
      commit('UPDATE_PUBLICATION', publication)
      if (newPhoto) {
        return dispatch('loadPublicationPhoto', { formData: newPhoto, id: publication.id })
      }
    })
  },
  getPublications ({ commit }) {
    return Vue.axios.get(`about/publications`)
    .then(({ data }) => commit('ADD_PUBLICATIONS', data))
  },
  getPublication ({ commit }, id) {
    return Vue.axios.get(`about/publications/${id}`)
    .then(({ data }) => commit('ADD_PUBLICATION', data))
  },
  loadPublicationPhoto ({ commit }, { formData, id }) {
    return Vue.axios.post(`about/publications/change-photo/${id}`, formData)
    .then(({ data }) => commit('UPDATE_PUBLICATION', data))
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/publications.js